module.exports = __webpack_public_path__ + "img/team-name-1.a61c2f86.png";